import React, { /*FC,*/ useEffect, useState } from 'react'
// import { GetAppointmentByIdOutput } from '../../../../Adaptor/TUBSIS/controllers/Appointments/models/getAppointmentModels'
import moment from 'moment'
import { /*deleteAppointment, getAppointmentsByExpertId, getUsersByUserGroup,*/ getUsersByUserGroupList } from '../../../../Adaptor/TUBSIS'
import { GetUsersByUserGroupListOutput/*, GetUsersByUserGroupOutput*/ } from '../../../../Adaptor/TUBSIS/controllers/UserGroups/models/getUserGroupModels'
// import {  Button, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

// type Props = {appointments: GetAppointmentByIdOutput[]}

const PatientTable = /*React.FC<Props> = ({ appointments })*/() => { 
  
    const [patientList, setPatientList] = useState<GetUsersByUserGroupListOutput[] | null>(null)
    const [selectedPatient, setSelectedPatient] = useState<GetUsersByUserGroupListOutput | null>(null)
    useEffect(() => {
      getUsersByUserGroupList("1,2,6")//get all users by user groups 1: TUBSIS / 2: POLSIS / 3: SBP (NO-SİS - Sigara Bırakma Polikliniği)
        .then((response) => {
          ////debugger
          if (response.data !== null) {
                const sortedItems = response.data.sort((a, b) => {
                    return b.userId - a.userId;
                });
                setPatientList(sortedItems)
                setFilteredPatientList(sortedItems??[]) 
          }
        })
        .catch((error) => {
          ////debugger
          console.log(error)
        })
    }, [])

    useEffect(() => {
        // Eğer patientList boş değilse ve en az bir uzman varsa
        if (patientList && patientList.length > 0) {
            // İlk danışan seç
            setSelectedPatient(patientList[0]);
        }
    }, [patientList]);

//   const handlePatientChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
//     const selectedPatientId = parseInt(event.target.value)
//     const selectedPatient = patientList?.find(patient => patient.userId === selectedPatientId) ?? null
//     setSelectedPatient(selectedPatient)
// }

const [filteredPatientList, setFilteredPatientList] = useState<GetUsersByUserGroupListOutput[]>([]); // Filtrelenmiş hasta listesi
const [searchTerm, setSearchTerm] = useState<string>(''); // Arama terimi

// Arama işlevi
const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const term = event.target.value;
    setSearchTerm(term); // Arama terimini güncelle

    const lowerTerm = term.toLocaleLowerCase('tr-TR'); // Türkçe'ye göre küçük harfe çevir

    // Arama terimine göre filtreleme yap
    const filteredList = patientList?.filter(patient => 
        patient.name.toLocaleLowerCase('tr-TR').includes(lowerTerm) ||
        patient.surname.toLocaleLowerCase('tr-TR').includes(lowerTerm) ||
        patient.citizenId.toString().includes(lowerTerm) // Arama terimi hastanın adında geçiyor mu?
    );
    setFilteredPatientList(filteredList ?? []); // Filtrelenmiş hasta listesini güncelle
};

const handleDeleteClick = (appointmentId: number) => {
    // Silme işlemine başlamadan önce kullanıcıyı uyaralım
    const isConfirmed: boolean = window.confirm("Randevuyu silmek istiyor musunuz?");

    // Eğer kullanıcı silmeyi onaylarsa devam edelim
    if (isConfirmed) {
        // Silme işlemini gerçekleştir
        // deleteAppointment(appointmentId)
        // .then((response) => {
        //   ////debugger
        //   console.log("delete",response.data)

        //   // Silinecek randevuyu filtrele
        //   const updatedAppointments = appointmentList?.filter(appointment => appointment.appointmentId !== appointmentId);
            
        //   // Güncellenmiş randevu listesini state'e uygula
        //   setAppointmentList(updatedAppointments??[]);
        // })
        // .catch((error) => {
        //   ////debugger
        //   console.log(error)
        // })
    }
};

const navigate = useNavigate();

    const handleButtonClick = (userId: number) => {
        // Yönlendirme yapmak için navigate fonksiyonu kullanılır
        // console.log("Bir sıkıntı yok")
        navigate(`/patient/details/${userId}`);
    };

    return (
        <div className='card p-5'>
            <div className="card-header border-0 py-5">
                <h3 className="card-title fw-bold">Danışan Listesi</h3>
                <div className="card-toolbar">
                    <input 
                        type="text" 
                        id="searchTerm" 
                        className="form-control form-control-solid" 
                        placeholder="Danışan Ara..." 
                        value={searchTerm} // Arama terimini buraya bağla
                        onChange={handleSearch}
                    />
                </div>
            </div>
            <div className='card-body'> 
                <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                    <thead>
                        <tr className="fw-bold text-gray-600">
                            <th className="w-25px">
                                <div className="form-check form-check-sm form-check-custom form-check-solid">
                                    <input className="form-check-input" type="checkbox" value="1" data-kt-check="true" data-kt-check-target=".widget-9-check"/>
                                </div>
                            </th>
                            <th className="min-w-200px">T.C. Kimlik Numarası</th>
                            <th className="min-w-150px">Danışan</th>
                            <th className="min-w-150px">Doğum Tarihi</th>
                            <th className="min-w-150px">Telefon Numarası</th>
                            <th className="min-w-150px">Program</th>
                            <th className="min-w-150px">Kayıt Tarihi</th>
                            <th className="min-w-100px text-end">İşlemler</th>
                        </tr>
                    </thead>
                    {filteredPatientList && filteredPatientList.length > 0 ? (
                    <tbody>
                        {filteredPatientList.map((patient, index) => (
                            <tr key={index}>
                                <td>
                                    <div className="form-check form-check-sm form-check-custom form-check-solid">
                                        <input className="form-check-input widget-9-check" type="checkbox" value="1"/>
                                    </div>
                                </td>
                                
                                <td>
                                    <div className="d-flex align-items-center">
                                        <div className="d-flex justify-content-start flex-column">
                                            <span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{patient.citizenId.toString()}</span>
                                        </div>
                                    </div>                                
                                </td>
                                
                                <td>
                                    <span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{patient.fullName}</span>
                                </td>
 
                                <td className="text-end">
                                    <div className="d-flex flex-column w-100 me-2">
                                        <div className="d-flex flex-stack mb-2">
                                            <span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">
                                                {moment(patient.birthDate).format('DD MMM YYYY')}
                                            </span>
                                        </div>
                                    </div>
                                </td>

                                <td>
                                    <div className="d-flex align-items-center">
                                        <div className="d-flex justify-content-start flex-column">
                                            <span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{patient.mobilePhones}</span>
                                        </div>
                                    </div>                                
                                </td>

                                <td>
                                    <div className="d-flex align-items-center">
                                        <div className="d-flex justify-content-start flex-column">
                                            <span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{patient.groupId === 1 ? "TÜBSİS" : (patient.groupId === 2 ? "POLSİS" : "SBP")}</span>
                                        </div>
                                    </div>                                
                                </td>

                                <td className="text-end">
                                    <div className="d-flex flex-column w-100 me-2">
                                        <div className="d-flex flex-stack mb-2">
                                            <span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">
                                                {moment(patient.recordDate).format('DD MMM YYYY HH:mm')}
                                            </span>
                                        </div>
                                    </div>
                                </td>
                                
                                {/* <td className="text-end">
                                    <div className="d-flex flex-column w-100 me-2">
                                        <div className="d-flex flex-stack mb-2">
                                            <h3> 
                                                {patient.status ? 
                                                <span className="badge badge-primary" style={{fontSize:"1.1rem"}}>EVET</span> : 
                                                <span className="badge badge-secondary" style={{fontSize:"1.1rem"}}>HAYIR</span>
                                                }
                                            </h3>
                                                
                                        </div>
                                    </div>
                                </td> */}

                                <td>
                                    <div className="d-flex justify-content-end flex-shrink-0">
                                        {/* <a href="#" className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                                            <i className="ki-duotone ki-switch fs-2"><span className="path1"></span><span className="path2"></span></i>                                    
                                        </a> */}
                                        {/*                                         
                                        <a href="#" className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                                            <i className="ki-duotone ki-pencil fs-2"><span className="path1"></span><span className="path2"></span></i>                                    
                                        </a> */}

                                        <button 
                                            type="button" 
                                            title='Danışan Bilgileri'
                                            className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm" 
                                            onClick={() => handleButtonClick(patient.userId)}>
                                            <i className="ki-duotone ki-pencil fs-2"><span className="path1"></span><span className="path2"></span></i>                                
                                        </button>

                                        {/* <button 
                                            type="button" 
                                            title='Danışanı Sil'
                                            className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm" 
                                            onClick={() => handleDeleteClick(patient.userId)}>
                                            <i className="ki-duotone ki-trash fs-2"><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span></i>                                    
                                        </button> */}

                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>)
                : (
                <tbody>
                    <tr>
                        <td>
                            <div className="form-check form-check-sm form-check-custom form-check-solid">
                                <input className="form-check-input widget-9-check" type="checkbox" value="1" disabled/>
                            </div>
                        </td>
                        <td>
                            <div className="d-flex align-items-center">
                                <div className="d-flex justify-content-start flex-column">
                                    <span className="text-gray-400 fw-bold text-hover-primary d-block fs-6">DANIŞAN BULUNAMADI.</span>
                                </div>
                            </div>     
                            {/* <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                                <div className="fs-3 text-muted">Randevu Bulunamadı.</div>
                            </div> */}
                        </td>
                    </tr>
                </tbody>)}
                </table>
            </div>
      </div>
    )
}

export default (PatientTable)